import {Observable, Subscription} from 'rxjs';

import EventType      from '../../Shared/Constants/EventType';
import dispatchEvent  from '../../Shared/Util/dispatchEvent';
import PlaybackStatus from '../../State/Stores/Playback/Constants/PlaybackStatus';
import IPlayer        from '../Interfaces/IPlayer';

const subscribeToPlaybackStatus = (
    playbackStatus$: Observable<PlaybackStatus>,
    player: IPlayer
): Subscription =>
    playbackStatus$
        .subscribe(playbackStatus => {
            const {playback} = player.state.stores;
            const {bufferingType} = playback.value;

            switch (playbackStatus) {
                case PlaybackStatus.BUFFERING:
                    dispatchEvent(player, EventType.BUFFER, bufferingType);

                    break;
                case PlaybackStatus.ENDED:
                    dispatchEvent(player, EventType.END);

                    break;
                case PlaybackStatus.PAUSED:
                case PlaybackStatus.ERRORED:
                    dispatchEvent(player, EventType.PAUSE);

                    break;
                case PlaybackStatus.A_LOADING:
                case PlaybackStatus.B_LOADING:
                    dispatchEvent(player, EventType.LOAD);

                    break;
                case PlaybackStatus.PLAYING:
                    dispatchEvent(player, EventType.PLAY);

                    break;
            }
        });

export default subscribeToPlaybackStatus;